import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';

interface DndArticleListSectionProps {
	meditationItems: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	meditationItems,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = meditationItems.find(
			(item: any) => item.id === active.id
		);
		const overItem = meditationItems.find((item: any) => item.id === over.id);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = meditationItems.findIndex(
			(item: any) => item.id === active.id
		);
		const overIndex = meditationItems.findIndex(
			(item: any) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={meditationItems.map((i: { id: any }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>{t('field.code')}</StyledTableCell>
								<StyledTableCell>{t('field.districtEn')}</StyledTableCell>
								<StyledTableCell>{t('field.districtZh')}</StyledTableCell>
								<StyledTableCell>{t('field.unitEn')}</StyledTableCell>
								<StyledTableCell>{t('field.unitZh')}</StyledTableCell>
								<StyledTableCell>{t('field.addressEn')}</StyledTableCell>
								<StyledTableCell>{t('field.addressZh')}</StyledTableCell>
								<StyledTableCell>{t('field.telNo')}</StyledTableCell>
								<StyledTableCell>{t('field.faxNo')}</StyledTableCell>
								<StyledTableCell>{t('field.email')}</StyledTableCell>
								<StyledTableCell>{t('field.nameIc')}</StyledTableCell>
								<StyledTableCell>{t('field.lastUpdated')}</StyledTableCell>
								<StyledTableCell>{t('field.status')}</StyledTableCell>
								<StyledTableCell>{t('field.actionedBy')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{meditationItems?.map((item: any) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '100px',
});
